<mat-form-field appearance="outline">
  <mat-label *ngIf="label"> {{ label }} </mat-label>

  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [formControl]="control"
    [attr.disabled]="isDisabled"
    (input)="onInputChange($event)"
    (focus)="onFirstClick()"
  />

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSelection($event)"
  >
    <mat-option
      *ngIf="noSelection"
      [value]="null"
    >
      -- None --
    </mat-option>

    <mat-option
      *ngFor="let option of options"
      [value]="option"
      [disabled]="option.count !== undefined && option.count <= 0"
    >
      <div class="flex-option">
        <span>{{ option.value }}</span>

        <mat-chip
          color="primary"
          highlighted
          *ngIf="option.count !== undefined"
        >
          <span style="display: none">(</span>{{ option.count }}<span style="display: none">)</span>
        </mat-chip>
      </div>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
